module.exports = __webpack_public_path__ + "static/media/undoAdmin.18db13c0.png";